// class name for expandable and collapsible accommodations note used to detect mutations in the dom
export const ACCOMMODATIONS_NOTE_TEXT_CLASS_NAME = 'accommodations-note-text';
